import React from "react";
import { NextUIProvider } from "@nextui-org/react";

export const wrapWithProviders = ({ element }) => {
  return <NextUIProvider>{element}</NextUIProvider>;
};

export default wrapWithProviders;
